import { gql } from "@apollo/client";

export type Review = {
  id: string;
  liked: boolean;
  feedback: string | null;
  feedback_timestamp: string;
  creation_date: string;
  total: number;
  client: {
    id: string;
    full_name: string;
    phone: string;
  } | null;
};

export type ReviewsResult = {
  getReviews: {
    reviews: Review[];
    total_count: number;
    liked_count: number;
    disliked_count: number;
  };
};

export const GET_REVIEWS = gql`
  query GetReviews($skip: Int, $take: Int) {
    getReviews(skip: $skip, take: $take) {
      reviews {
        id
        liked
        feedback
        feedback_timestamp
        creation_date
        total
        client {
          id
          full_name
          phone
        }
      }
      total_count
      liked_count
      disliked_count
    }
  }
`;
